import {StringValidacao} from './string';
import {Construtor} from './construtor';
import {Usuario} from './usuario';
import {RoteiroPontoFisico} from './roteiro-ponto-fisico';

export class Roteiro implements Construtor<Roteiro> {

  public idRoteiro: number;
  public descricaoRoteiro: string;
  public idCliente: number;
  public dataInicioRoteiro: Date;
  public dataFimRoteiro: Date;
  public usuario: Usuario;
  public pontosFisicos: RoteiroPontoFisico[];

  constructor(object?: any) {
    this.usuario = new Usuario();
    this.pontosFisicos = new Array<RoteiroPontoFisico>();

    if (object !== undefined) {
      if (object instanceof (Roteiro)) {
        this.copyObject(object);
      } else if (object instanceof (Usuario)) {
        this.usuario = object;
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  get obterIdRoteiro(): number {
    return this.idRoteiro;
  }

  set IdRoteiro(id: any) {
    this.idRoteiro = id;
  }

  get obterDescricaoRoteiro(): string {
    return this.descricaoRoteiro.slice(0);
  }

  set DescricaoRoteiro(descricao: any) {
    this.descricaoRoteiro = StringValidacao.copiarStringValida(descricao);
  }

  get obterUsuario(): Usuario {
    return this.usuario;
  }

  set Usuario(user: any) {
    this.usuario = user;
  }

  get obterIdCliente(): number {
    return this.idCliente;
  }

  set IdCliente(id: any) {
    this.idCliente = id;
  }

  get obterDataInicioRoterio(): Date {
    return this.dataInicioRoteiro;
  }

  set DataInicioRoteiro(data: any) {
    this.dataInicioRoteiro = data;
  }

  get obterDataFimRoterio(): Date {
    return this.dataFimRoteiro;
  }

  set DataFimRoteiro(data: any) {
    this.dataFimRoteiro = data;
  }

  get obterPontosFisicos(): RoteiroPontoFisico[] {
    return this.pontosFisicos;
  }

  set insertPontoFisico(pontoFisico: RoteiroPontoFisico) {
    this.pontosFisicos.push(pontoFisico);
  }

  set PontosFisicos(pontosFisicos: any) {

    this.pontosFisicos = new Array<RoteiroPontoFisico>();

    if (pontosFisicos !== undefined) {
      for (const pontoFisico of pontosFisicos) {
        this.insertPontoFisico = new RoteiroPontoFisico(pontoFisico);
      }
    }
  }

  copyObject(roteiro: Roteiro): void {
    this.idRoteiro = roteiro.obterIdRoteiro;
    this.descricaoRoteiro = roteiro.obterDescricaoRoteiro;
    this.usuario = roteiro.obterUsuario;
    this.idCliente = roteiro.obterIdCliente;
    this.dataInicioRoteiro = new Date(roteiro.obterDataInicioRoterio);
    this.dataFimRoteiro = new Date(roteiro.obterDataFimRoterio);
    this.pontosFisicos = roteiro.obterPontosFisicos;
  }

  parseFromJson(roteiro: any): void {
    this.IdRoteiro = roteiro.idRoteiro;
    this.DescricaoRoteiro = roteiro.descricaoRoteiro;
    this.Usuario = roteiro.usuario;
    this.IdCliente = roteiro.idCliente;
    this.DataInicioRoteiro = new Date(roteiro.dataInicioRoteiro);
    this.DataFimRoteiro = new Date(roteiro.dataFimRoteiro);
    this.pontosFisicos = roteiro.pontosFisicos;
  }

  modeloCompleto(): boolean {
    return this.DescricaoRoteiro !== undefined;
  }

  getNewInstance(object?: any): Roteiro {
    return new Roteiro(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/roteiro.ts